let _api, _location, _state, _q, _atm;

const _ = require('lodash'), angular = require('angular'), $ = require('jquery'), UrlInfo = require('../../../common/components/urlinfo/url-info.js');

const cache = {};

const atmDataMapper = require('./page-title-mapper.js');

const pushatm = function (data, state) {
    const isHomepageEnabled = true;
    if (state && state.current && (state.current.name === 'shop.browse' || isHomepageEnabled && state.current.name === 'root')) {
        data = $(document).attr('title');
    }

    if (state && state.current) {
        _atm.push(data, atmDataMapper);
    }
};
function PageMetadata(restangular, $location, $state, $q, atm) {
    _api = restangular.one('SeoMetatags');
    _location = $location;
    _state = $state;
    _q = $q;
    _atm = atm;
    this.isNoIndexPage = undefined;
}

PageMetadata.prototype.defaultMetadata = {
    title: '',
    metaDescription: '',
    headerScript: '',
    metaRobot: '',
    meta404: '',
    metaPrevUrl: '',
    metaNextUrl: '',
    openGraph: {
        image: ''
    }
};

function normalize(metaData, skipATM) {
    const title = metaData.Title || metaData.title || '';
    const metaDescription = metaData.MetaDescription || metaData.metaDescription || '';
    const metaRobot = this.isNoIndexPage
        ? 'noindex, nofollow'
        : metaData.MetaRobot || metaData.metaRobot || null;
    const meta404 = metaData.meta404 || null;
    const openGraph = metaData.openGraph || { image: '' };

    PageMetadata.title = title;

    if (!skipATM) {
        pushatm(title, _state);
    }
    return {
        title,
        metaDescription,
        headerScript: metaData.HeaderScript,
        metaRobot,
        meta404,
        metaPrevUrl: metaData.metaPrevUrl || this.metaPrevUrl,
        metaNextUrl: metaData.metaNextUrl || this.metaNextUrl,
        openGraph
    };
}

PageMetadata.prototype.controlSeries = function (currentPage, totalPages) {
    const currentUrl = _location.url();
    const urlInfo = new UrlInfo(currentUrl);

    if (currentPage > totalPages) {
        this.metaNextUrl = this.metaPrevUrl = '';
    }

    // if current pageNumber 1, do not show prev
    if (currentPage === 1) {
        // don't show previous
        this.metaPrevUrl = '';
    } else {
        //show previous
        const prevPage = currentPage - 1;
        if (prevPage > 1) {
            urlInfo.search({ pageNumber: prevPage }, true);
        } else {
            urlInfo.search({}, true);
        }

        this.metaPrevUrl = urlInfo.href();
    }

    // if current page is last page, do not show next
    if (currentPage === totalPages) {
        // don't show next
        this.metaNextUrl = '';
    } else {
        const nextPage = currentPage + 1;
        urlInfo.search({ pageNumber: nextPage }, true);
        this.metaNextUrl = urlInfo.href();
    }
};

/**
 * Gets metadata from the server which has been set up in site management.
 * @param {Object} formatObject - The format object contains key/value pairs which can be used in
 *  the format string which is set up in site management
 * @param {boolean} [isSpecial] - If this is true, will only search for metadata created for
 *  specials pages.
 * @param {String} urlPath - This is the key which metadata is created against and which will be
 *  used to search for the metadata.
 * @param {String} [pageType] - This is used to search for metadata from only one of these categories:
 *  Department, Aisle, LandingPage, Product, Recipe, FreeText, RecipeCategory, Home.
 * @param {Object} extraMetadata - Key/value pairs to merge into the metadata result returned from
 *  the server (e.g. opengraph metadata).
 * @returns {Promise}
 */
PageMetadata.prototype.getMetadata = function (formatObject, isSpecial, urlPath, pageType, extraMetadata) {
    const path = urlPath || _location.path();
    const special = isSpecial || false;
    const key = path + '-' + special + '-' + pageType;
    return key in cache
        ? _q.when(cache[key])
        : _api.get({
            UrlPath: path,
            IsSpecial: special,
            FormatObject: JSON.stringify((formatObject || {})),
            PageType: pageType
        })
            .then(function (metaResponse) {
                return _.assign(metaResponse, extraMetadata);
            })
            .then(normalize.bind(this))
            .then(function (result) {
                cache[key] = result;
                const head = document.head;
                if (result.headerScript) {
                    const scriptTag = document.createRange().createContextualFragment(result.headerScript);
                    head.appendChild(scriptTag);
                }
                return result;
            });
};

PageMetadata.prototype.getCurrentMetadata = function () {
    return {
        title: this.title,
        metaDescription: this.metaDescription,
        headerScript: this.headerScript,
        metaRobot: this.metaRobot,
        meta404: this.meta404,
        metaPrevUrl: this.metaPrevUrl,
        metaNextUrl: this.metaNextUrl,
        openGraph: this.openGraph
    };
};

PageMetadata.prototype.setMetadata = function (metaData, skipATM) {
    if (!metaData) {
        return;
    }

    if (angular.isFunction(metaData.then)) {
        metaData.then(this.setMetadata.bind(this));
    } else {
        _.assign(this, normalize.call(this, metaData, skipATM));
    }
};

/**
 * Gets and sets metadata from the server which has been set up in site management.
 * @param {Object} formatObject - The format object contains key/value pairs which can be used in
 *  the format string which is set up in site management
 * @param {boolean} [isSpecial] - If this is true, will only search for metadata created for
 *  specials pages.
 * @param {String} urlPath - This is the key which metadata is created against and which will be
 *  used to search for the metadata.
 * @param {String} [pageType] - This is used to search for metadata from only one of these categories:
 *  Department, Aisle, LandingPage, Product, Recipe, FreeText, RecipeCategory, Home.
 * @param {Object} extraMetadata - Key/value pairs to merge into the metadata result returned from
 *  the server (e.g. opengraph metadata).
 * @returns {Promise}
 */
PageMetadata.prototype.updateMetadata = function (formatObject, isSpecial, urlPath, pageType, isNoIndexPage, extraMetaData) {
    this.isNoIndexPage = isNoIndexPage;
    return this.getMetadata(formatObject, isSpecial, urlPath, pageType, extraMetaData).then(this.setMetadata.bind(this));
};

PageMetadata.prototype.useCurrentStateMetadata = function () {
    if (_state.shouldGetMetaData()) {
        this.setMetadata(_state.getMetadata());
    }
};

/**
 * Gets a normalised canonical Url
 * @param {String} urlName - The string fragment in the URL to be replaced. Can be undefined
 * @param {String} newName - The string that replaces urlName, or is appended to the baseURL. Can be undefined
 * @returns {String}
 */
PageMetadata.prototype.getNormalizedCanonicalUrl = function (urlName, newName) {
    const url = _location.absUrl();
    const baseUrl = url.indexOf('?') === -1 ? url : url.split('?')[0];

    // Canonical Url default to baseUrl
    let canonicalUrl = baseUrl;

    /*
    * Do a replacement/append if newName exists
    * Replacement: eg. product group Id with Product group name
    * Append: eg. sometimes no product name is in the URL
    */
    if (newName) {
        canonicalUrl = urlName
            ? baseUrl.replace(new RegExp(urlName + '$'), newName)
            : baseUrl + newName;
    }

    // Returns cleaned up canonicalUrl without trailing forward slash and also replace any number of spaces or %20 with single hyphen (-)
    return canonicalUrl.replace(/\/$/, '').replace(/(?:%20|\s)+/g, '-').toLowerCase();
};

PageMetadata.prototype.pushAtm = function () {
    pushatm(PageMetadata.title, _state);
};

module.exports = PageMetadata;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/pagemetadata/page-metadata-service.js
 **/